module.exports = __webpack_public_path__ + "img/waving.8447ee67.png";